/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by sebastien on 13/12/19.
 *
 * Version : Generator 2.0.9
 */


import {Injectable} from '@angular/core';
// @ts-ignore
import * as sha1 from 'js-sha1';
import {LogService} from '../log/logService';
import {CordovaBackService} from '../service';
import {FileData, FileStatus, FileType} from './entity';
import {StatusEnum} from '../entity';


@Injectable()
export class MsaService {
    /**
     * Library Version
     */
    private _libraryVersion: string = '2.0.9';
    /**
     * Library Date
     */
    private _libraryDate: string = '2022-02-28T15:48:22.706Z';
    /**
     * LogService
     * @type {null}
     */
    private _logService: LogService = null;
    /**
     * Connectivity Quality Sync
     */
    private connectivityQualityFunction: () => Promise<boolean>;
    /**
     * Connectivity Sync
     */
    private connectivityFunction: () => Promise<boolean>;
    /**
     * Blob Url Cache.
     */
    private blobUrlCache: string[] = [];
    /**
     * File Cache.
     */
    private fileCache: Map<string, FileData> = new Map<string, FileData>();


    /**
     * Constructor.
     */
    constructor(private cordovaBackService: CordovaBackService) {
        this._logService?.logLog('-- MsaService MsaService -- version ONLINE', 'MsaService', 'constructor', 2);
        this.initData();
    }

    /**
     * init Data
     */
    private initData(): void {
        this.connectivityQualityFunction = this.defaultEventFunction;
        this.connectivityFunction = this.cordovaBackService.connectivityFunction;
    }


    /**
     * Event Function for Item Sync.
     */
    public defaultEventFunction(): Promise<boolean> {
        return new Promise(
            (resolve) => {
                resolve(true);
            });
    }

    /**
     * Add an url to the blob cache.
     * @param uri to add
     */
    public addBlobUrlCache(uri: string) {
        this.blobUrlCache.push(uri);
    }

    /**
     * Clear the blob url of navigator.
     */
    public clearBlobUrlCache(): void {
        this._logService?.logLog('clearBlobUrlCache', 'MsaService', 'clearBlobUrlCache', 3);
        for (const blobUrl of this.blobUrlCache) {
            this._logService?.logLog('clearBlobUrlCache ...........revokeObjectURL ' + blobUrl, 'MsaService', 'clearBlobUrlCache', 3);
            URL.revokeObjectURL(blobUrl);
        }
        this.blobUrlCache = [];
        this.fileCache.clear();
    }

    /**
     * Compute the uri for FileData
     * @param fileData
     */
    public computeUriForFileData(fileData: FileData): void {
        switch (fileData.file_type) {
            case FileType.BLOB:
                if (fileData.blob != null) {
                    fileData.uri = URL.createObjectURL(fileData.blob);
                    this.blobUrlCache.push(fileData.uri);
                    this._logService?.logLog('computeUriForFileData .........____________ createObjectURL ' + fileData.uri,
                        'MsaService', 'computeUriForFileData', 3);
                } else {
                    fileData.file_status = FileStatus.ERROR;
                }
                break;
            case FileType.FILE:
                fileData.uri = CordovaBackService.convertPath(
                    CordovaBackService.getDataDirectory() + fileData.file_path);
                break;

        }
    }

    /**
     * Return a promise who resolve when it's ready to start.
     * @return {Promise<StatusEnum>}
     */
    public isReadyToStart(): Promise<StatusEnum> {
        this._logService?.logLog('-- MsaService isReadyToStart -- TimeOut', 'MsaService', 'isReadyToStart', 3);
        return new Promise(
            (resolve) => {
                resolve(StatusEnum.OK);
            });
    }

    /**
     * Setter.
     * @param {LogService} value
     */
    public set logService(value: LogService) {
        this._logService = value;
        this._logService.setEventConnectivityQuality(this.connectivityQualityFunction);
        this._logService.setEventConnectivity(this.connectivityFunction);
    }

    /**
     * Get the library modele
     */
    public get libraryVersion(): string {
        return this._libraryVersion;
    }

    /**
     * Get the library Date
     */
    public get libraryDate(): string {
        return this._libraryDate;
    }
}
